/*
 * Hulk Advanced Wishlist – accessibility patch
 *
 * Covers:
 *  - Collection grids: hulkapps-wishlist-collection.js removes the theme's
 *    [data-gridhulklist] buttons and injects its own <a data-gridwlhulklist>
 *    with no text, no role and no state. This names them, gives them button
 *    semantics and keyboard (Space) activation.
 *  - Theme snippet buttons ([data-gridhulklist]) and the PDP app-block button:
 *    keeps aria-label / aria-pressed in sync with Hulk's data-added state.
 *
 * Remove the collection-grid part once Hulk ships accessible markup in the app.
 */
(function () {
  'use strict';

  var SEL = [
    'a[data-gridwlhulklist]',
    '[data-gridhulklist].wishlist-btn',
    '.product-image-container [data-wishlist].wishlist-btn'
  ].join(',');

  function productName(el) {
    var card = el.closest('product-card');
    var t = card
      ? card.querySelector('.product-card-title')
      : (el.closest('.thb-product-detail') || document).querySelector('h1');
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function isAdded(el) {
    return el.getAttribute('data-added') === 'true' ||
      el.classList.contains('icon-wishlist-heart-full');
  }

  function label(el) {
    var name = productName(el);
    var added = isAdded(el);
    var text = (added ? 'Remove ' : 'Add ') + (name ? name + ' ' : '') + (added ? 'from' : 'to') + ' wishlist';

    if (el.tagName === 'A') {
      el.setAttribute('role', 'button');
      if (!el.dataset.wlA11yKeys) {
        el.dataset.wlA11yKeys = '1';
        el.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            el.click();
          }
        });
      }
    } else if (el.tagName === 'BUTTON' && !el.hasAttribute('type')) {
      el.setAttribute('type', 'button');
    }

    if (el.getAttribute('aria-label') !== text) el.setAttribute('aria-label', text);
    el.setAttribute('aria-pressed', added ? 'true' : 'false');

    var icons = el.querySelectorAll('i, svg, img');
    for (var i = 0; i < icons.length; i++) {
      if (icons[i].tagName === 'IMG') icons[i].setAttribute('alt', '');
      else icons[i].setAttribute('aria-hidden', 'true');
    }
  }

  function scan(root) {
    if (root.matches && root.matches(SEL)) label(root);
    if (root.querySelectorAll) {
      var els = root.querySelectorAll(SEL);
      for (var i = 0; i < els.length; i++) label(els[i]);
    }
  }

  function init() {
    scan(document);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          if (m.target.matches && m.target.matches(SEL)) label(m.target);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (m.addedNodes[j].nodeType === 1) scan(m.addedNodes[j]);
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-added', 'class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
